
const PublicacionesInfo = [
  {
    id: '1',
    title: 'Programa Anual de Evaluación para el Desarrollo del Estado de Hidalgo',
    author: 'Gobierno del Estado de Hidalgo',
    category: 'Programa Anual',
    date: '2023',
    pages: '10 págs.',
    coverImage: '/assets/imgs/portada/paed2023.jpeg',
    pdfUrl: '/assets/pdf/paed/PAEDH2023.pdf'
  },
  {
    id: '2',
    title: 'Programa Anual de Evaluación para el Desarrollo del Estado de Hidalgo',
    author: 'Gobierno del Estado de Hidalgo',
    category: 'Programa Anual',
    date: '2024',
    pages: '11 págs.',    
    coverImage: '/assets/imgs/portada/paed2024.jpeg',
    pdfUrl: '/assets/pdf/paed/PAEDH2024.pdf'
  },
  {
    id: '3',
    title: 'Programa Anual de Evaluación para el Desarrollo del Estado de Hidalgo',
    author: 'Gobierno del Estado de Hidalgo',
    category: 'Programa Anual',
    date: '2025',
    pages: '13 págs.', 
    coverImage: '/assets/imgs/portada/paed2025.jpeg',
    pdfUrl: '/assets/pdf/paed/PAEDH2025.pdf'
  },
  {
    id: '4',
    title: 'Programa Anual de Evaluación para el Desarrollo del Estado de Hidalgo',
    author: 'Gobierno del Estado de Hidalgo',
    category: 'Programa Anual',
    date: '2026',
    pages: '8 págs.', 
    coverImage: '/assets/imgs/portada/paed2026.jpeg',
    pdfUrl: '/assets/pdf/paed/PAEDH2026.pdf'
  }
];

export default PublicacionesInfo;